import { attributeValidators } from './attributeValidators';

export default function chatValidationErrors(action) {
    let errors =  Object.keys(attributeValidators).reduce((errors, validator) => {
        errors[validator] = !attributeValidators[validator](action)
        return errors;
    }, {})
    return errors;
}